export default { sha: '2a6098f8cc484d12d8922104c93314b1472d280c', buildNumber: 'undefined' }
